import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function PublicRoute() {
  const { isLoading, isAuthenticated, phoneRepair } = useAuth();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={phoneRepair?.shouldShow ? "/phone-repair" : "/home"} replace />;
  }

  return <Outlet />;
}
